var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8222 12.8049C15.1359 12.8049 17.7932 10.1146 17.7932 6.83389C17.7932 3.55393 15.1366 0.830664 11.8222 0.830664C8.50858 0.830664 5.85127 3.52096 5.85127 6.80163C5.85127 10.0816 8.50787 12.8049 11.8222 12.8049ZM11.8222 2.57905C14.1541 2.57905 16.0448 4.46976 16.0448 6.80163C16.0448 9.1335 14.1541 11.0242 11.8222 11.0242C9.48939 11.0242 7.59965 9.16478 7.59965 6.83389C7.59965 4.50105 9.49133 2.57905 11.8222 2.57905ZM1.62869 21.9984H22.0803C22.5549 21.9984 22.9545 21.5988 22.9545 21.1242C22.9545 17.0045 19.5871 13.6371 15.4674 13.6371H8.24159C4.12184 13.6371 0.754492 17.0045 0.754492 21.1242C0.754492 21.5988 1.1541 21.9984 1.62869 21.9984ZM8.24159 15.3855H15.4674C18.3447 15.3855 20.6979 17.4834 21.1261 20.25H2.58291C3.01104 17.4834 5.36424 15.3855 8.24159 15.3855Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7bd609724095fbfc2fcdcb2f55be34db.svg";
export { ForwardRef as ReactComponent };